import { useEffect } from "react";

const useGoogleAnalytics = (trackingId) => {
  useEffect(() => {
    if (!trackingId) {
      console.error("Google Analytics Tracking ID is required.");
      return;
    }

    // Load the gtag script dynamically
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script);

    // Initialize Google Analytics after the script is loaded
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", trackingId);
    };

    return () => {
      // Clean up: remove the script when the component using the hook unmounts
      document.head.removeChild(script);
    };
  }, [trackingId]);

  // A function to log custom events
  const logEvent = (action, params) => {
    if (!window.gtag) {
      console.error("Google Analytics is not initialized.");
      return;
    }
    window.gtag("event", action, params);
  };

  return { logEvent };
};

export default useGoogleAnalytics;
